import PropTypes from 'prop-types';
import React from 'react';
import { partnerShape } from '../types';
import BasePartnerAppSitesSummary from './BasePartnerAppSitesSummary';
import UserConfigurationAppSitesSummary from './UserConfigurationAppSitesSummary';

const PartnerAppSitesSummaryFactory = props => {
    const { accountsSupport } = props;

    if (accountsSupport) {
        return <UserConfigurationAppSitesSummary {...props} />;
    } else {
        return <BasePartnerAppSitesSummary {...props} />;
    }
};

PartnerAppSitesSummaryFactory.propTypes = {
    partner: partnerShape.isRequired,
    accountsSupport: PropTypes.bool,
};

export default PartnerAppSitesSummaryFactory;
